module.exports = __webpack_public_path__ + "media/evolve/assets/icons/static/help-b20d2e22838fa866bef8fa374db9c667.svg";